import * as React from 'react';
import {
  Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography,
  Alert, Avatar, Box, FormControl, InputLabel, MenuItem, Select, Stack, TextField
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
// import { useSnackbar } from 'notistack';

import { useGetAllDevisesQuery } from "../../app/services/deviseApi";
import { useAddCourMutation } from "../../app/services/courApi";
import Loader from '../loader/Loader';
import dayjs from 'dayjs';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function AddCoursModel(props) {
//   const { enqueueSnackbar } = useSnackbar();
  const { data: devises, isLoading } = useGetAllDevisesQuery();
  const [addCour, { isLoading: isAdding }] = useAddCourMutation();

  const [open, setOpen] = React.useState(false);
  const [selectedDeviseId, setSelectedDeviseId] = React.useState('');
  const [prixAchat, setPrixAchat] = React.useState('');
  const [prixVente, setPrixVente] = React.useState('');
  const [errorMsg, setErrorMsg] = React.useState('');

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setSelectedDeviseId('');
    setPrixAchat('');
    setPrixVente('');
    setErrorMsg('');
  };

  const handleForm = async (e) => {
    e.preventDefault();
    setErrorMsg('');

    try {
      await addCour({
        devise_id: selectedDeviseId,
        bureau_id: props.Bureau.id,
        prixAchat: parseFloat(prixAchat),
        prixVente: parseFloat(prixVente),
        date_cours: dayjs().format('YYYY-MM-DD'),
      }).unwrap();

    //   enqueueSnackbar("Cours ajouté avec succès !", { variant: 'success' });
      handleClose();
    } catch (err) {
      console.error(err);
      if (err?.data?.errors) {
        setErrorMsg(Object.values(err.data.errors).join(' '));
      } else if (err?.data?.message) {
        setErrorMsg(err.data.message);
      } else {
        setErrorMsg("Erreur lors de l'ajout du cours.");
      }
    }
  };

  if (isLoading) return <Loader />;
  if (!devises) return <Alert severity="error">Erreur de chargement des devises</Alert>;

  return (
    <React.Fragment>
      <Button variant="contained" onClick={handleClickOpen}>
        Ajouter Cours
      </Button>
      <BootstrapDialog onClose={handleClose} open={open}>
        <DialogTitle sx={{ m: 0, p: 2 }}>
          Ajouter un cours
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Typography gutterBottom>
            {props.Bureau.nom} - {props.Bureau?.quartier}
          </Typography>

          <form id="coursForm" onSubmit={handleForm}>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
              <Stack direction="column" spacing={2} sx={{ flex: 1 }}>
                <FormControl fullWidth>
                  <InputLabel id="receive-select-label">Devise</InputLabel>
                  <Select
                    labelId="receive-select-label"
                    value={selectedDeviseId}
                    label="Devise"
                    onChange={(e) => setSelectedDeviseId(e.target.value)}
                    size="small"
                    required
                  >
                    {devises.map((devise) => (
                      <MenuItem value={devise.id} key={devise.id}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <Avatar
                            alt={devise.name}
                            src={`${process.env.REACT_APP_BASE_FILE_URL}/Devise/image/${devise.image}`}
                            sx={{ width: 24, height: 24 }}
                          />
                          {devise.name}
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <TextField
                  label="Prix d'achat"
                  type="number"
                  value={prixAchat}
                  onChange={(e) => setPrixAchat(e.target.value)}
                  required
                  size="small"
                />

                <TextField
                  label="Prix de vente"
                  type="number"
                  value={prixVente}
                  onChange={(e) => setPrixVente(e.target.value)}
                  required
                  size="small"
                />

                {errorMsg && (
                  <Alert severity="error">{errorMsg}</Alert>
                )}
              </Stack>
            </Stack>
          </form>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Annuler</Button>
          <Button
            type="submit"
            form="coursForm"
            variant="contained"
            disabled={isAdding}
          >
            {isAdding ? 'Enregistrement...' : 'Enregistrer'}
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}
